import styled from 'styled-components';
import StyledAnchor from './StyledAnchor';

const StyledAnchorAsButton = styled(StyledAnchor).attrs<{ type: string }>(
  props => ({
    type: props.type ?? 'button',
    as: 'button'
  })
)`
  appearance: none;
`;

export default StyledAnchorAsButton;
